import rs from './rs'
export default {
  rs
}